import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { useSelector, useDispatch } from 'react-redux';
import { analyticsActions } from '../../../redux/analytics/actions/AnalyticsActions.creators';
import { makeGetProductVariants, makeGetProductInfo } from '../../../redux/product/selectors/ProductSelector';
import { getProductDetailUrl } from '../../../util/ProductUtil';
import { ProductVariantButtonsAlpha } from '../product-variant-buttons/ProductVariantButtonsAlpha';
export const ProductVariantsAlpha = () => {
    const { root } = useAemConfig();
    const productVariants = useSelector(makeGetProductVariants());
    const { productCode } = useSelector(makeGetProductInfo());
    const dispatch = useDispatch();
    const handleVariantClick = (variant) => () => {
        dispatch(analyticsActions.productVariantClick());
        window.location.href = getProductDetailUrl({ seoUrl: variant.productSeoUrl, colourId: variant.colorId }, root);
    };
    if (!(productVariants === null || productVariants === void 0 ? void 0 : productVariants.length)) {
        return null;
    }
    return (_jsx(ProductVariantButtonsAlpha, { productVariants: productVariants, productCode: productCode, handleVariantClick: handleVariantClick }));
};
